/**
 * =================
 * TABS
 * tool
 * =================
 */
app.tabs = (function(module) {

    module.init = function($els) {
        $els.each(function() {
            _init(app.$(this));
        });
    };

    // fn's
    function _init($el) {
        var $tabs  = $el.find('.tab'),
        $panes = $el.find('.tabbed-pane'),
        index  = Math.max(0, $tabs.index($tabs.filter('.active')));

        $tabs.eq(index).addClass('active');
        $panes.hide().eq(index).show();

        // beware dupe events on re-inits
        $tabs.off('click.tabs').on('click.tabs', function(e) {
            e.preventDefault();
            index = $tabs.index(this);
            $tabs.removeClass('active').eq(index).addClass('active');
            $panes.hide().eq(index).show();
            // subscribable onShow tabs event
            $el.trigger('show.tabs');
            var $this = app.$(this);
            if ( $this.hasClass("expanded") ) {
                $el.addClass("expanded-tab");
            } else {
                $el.removeClass("expanded-tab");
            }
            // swiper init
            // if ( app.$($panes.eq(index).find('.md-slider-table') ) ) { app.slidersTable.init( $panes.eq(index).find('.md-slider-table') ); }
        });
    }

    // kickstart!
    app.$(function() {
        module.init(app.$('.tabbed'));
    });

	return module;

}(app.tabs || {}));
